import { FeedbackType } from "./types/queries";
import { Relation } from "../../common/types/Paginated";

export const MOCK_FEEDBACKS = {
  hits: {
    value: 2,
    relation: Relation.EQ,
  },
  data: [
    {
      id: "deadbeef_NxMybtUzsNrSzkmqBd3qgQ",
      targetAggregateId: "NxMybtUzsNrSzkmqBd3qgQ",
      reporter: {
        id: "deadbeef",
        firstName: "James",
        lastName: "Bond",
      },
      type: "CUSTOMER_FEEDBACK_WORKTIMEENTRY" as FeedbackType,
      // type: "TALENT_FEEDBACK_WORKLOCATION" as FeedbackType,
      // type: "CUSTOMER_FEEDBACK_TALENT" as FeedbackType,
      workLocationId: "wrkl050101",
      workLocationName: "Kodin Remonttityöt Oy",
      worktimeEntry: {
        id: "NxMybtUzsNrSzkmqBd3qgQ",
        start: 1747900800000,
        end: 1747929600000,
        workTitleId: "wt161",
      },
      talent: {
        id: "id-maksukielto-jariokonen-lajikoodi4-suojaosuus-kylla",
        firstName: "Jari",
        lastName: "Okonen-UO4-TEST",
      },
      comment:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue.",
      createdAt: 1746592688388,
      acknowledgedBy: "",
    },
  ],
  cursor: "WzE3NDY1OTI2ODgzODhd",
};
